import { CustomFieldData } from './CustomField';

export interface CreateContract {
  amount: number;
  delay: number;
  prepayment: number;
  prepaymentDate: string;
  comment?: string | null | undefined;
  discount?: number;
  discountDescription?: string;
  clientId: number;
  flats: {
    flatId: number;
    repaired: boolean;
    discountAmount?: number;
    terraceDiscountAmount?: number;
  }[];
  monthlyPaymentPartDtos?: MonthlyPayment[] | null;
  number: string | null;
  delayInterval: number;
  brokerId: number;
  responsibleBy: number;
  fields: CustomFieldData[];
  currencyId: number;
  discountPercent?: number | null;
  discountPartId?: number | null;
  mortgage?: number;
  mortgagePaymentDate?: string;
  monthlyPaymentAmount?: number;
  offerAmount?: number;
  offerPositive?: boolean;
  remainingAmount?: number;
  remainingPaymentDate?: string;
  realtorId?: number;
  prepaymentParts?: {
    prepayment: number;
    prepaymentDate: string;
  }[];
}

export interface MonthlyPayment {
  id?: number;
  amount: number;
  amountString: string;
  date: string;
  payment?: number;
  prepayment?: boolean;
  paid?: true;
  sum?: number;
  type: 'PREPAYMENT' | 'MORTGAGE' | 'MONTHLY_PAYMENT' | 'REMAINING';
}

export enum MonthlyPaymentStatus {
  ACTIVE = 'ACTIVE',
  ARCHIVE = 'ARCHIVE'
}
